import { intervalToDuration, parseISO } from "date-fns";
import { useEffect, useState } from "react";
interface ElapsedTimerProps {
  startTime: string | number | null;
  endTime?: string | number | null;
  className?: string;
}
export const ElapsedTimer = ({
  startTime,
  endTime,
  className
}: ElapsedTimerProps) => {
  const [now, setNow] = useState<number>(Date.now());
  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  if (!startTime) {
    return <span className={className}>Not started</span>;
  }
  const getElapsedTime = () => {
    const start = typeof startTime === "string" ? parseISO(startTime) : new Date(startTime);
    const end = endTime ? typeof endTime === "string" ? parseISO(endTime) : new Date(endTime) : new Date(now);
    const {
      hours = 0,
      minutes = 0,
      seconds = 0
    } = intervalToDuration({
      start,
      end
    });
    const mm = String(minutes).padStart(2, "0");
    const ss = String(seconds).padStart(2, "0");
    if (hours > 0) {
      const hh = String(hours).padStart(2, "0");
      return `${hh}:${mm}:${ss}`;
    } else {
      return `${mm}:${ss}`;
    }
  };
  return <span className={className} key={now} data-sentry-component="ElapsedTimer" data-sentry-source-file="ElapsedTimer.tsx">
      {getElapsedTime()}
    </span>;
};